export default "__VITE_ASSET__bc6c1f49__"